import React from "react";
import { CheckIcon, XIcon } from "../../../constants/Icons";

const ConfirmSubmitModal = ({ open, onClose, onConfirm }) => {
  if (!open) return null;

  return (
    <>
      <div className="modal-backdrop show"></div>

      <div
        className="modal show"
        tabIndex="-1"
        role="dialog"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Confirm Submission</h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
              ></button>
            </div>

            <div className="modal-body text-center bg-light">
              <p className="mb-0">Are you sure you want to Create Proforma?</p>
            </div>

            <div className="modal-footer d-block">
              {/* ❌ NO */}
              <button
                type="button"
                className="btn shadow-none btn-outline-secondary text-left"
                onClick={onClose}
              >
                <XIcon iClass={"fs-15"}/> Cancel
              </button>

              {/* ✅ YES */}
              <button
                className="btn btn-porforma  text-right"
                onClick={onConfirm}
              >
                <CheckIcon/> Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConfirmSubmitModal;
